<template>
    <section class="product-tabs">
        <div class="container">
            <nav>
                <div class="left">
                    <ul>
                        <li v-for="(item, key) in data"
                            :key="key"
                            :class="{ active: isActive(key) }"
                            @click.prevent="setActive(key)"
                        >
                            {{ item.title }}
                        </li>
                    </ul>
                </div>
                <!--<div class="right"></div>-->
            </nav>

            <div class="tab-content"
                 v-for="(item, key) in data"
                 :key="key"
                 :class="{ show: isActive(key) }"
            >
                <template v-if="item.type === 'description'">
                    <div v-html="item.data"></div>
                </template>
                <template v-else-if="item.type === 'parameters'">
                    <table v-if="item.properties && item.properties.length">
                        <tbody>
                            <tr v-for="(property, key) in item.properties"
                                :key="key"
                            >
                                <td><strong>{{ property.name }}</strong></td>
                                <td v-if="property.input === 'checkbox'">{{ property.pivot.value === '1' ? 'Áno' : 'Nie' }}</td>
                                <td v-else-if="property.input === 'select'">{{ getSelectValue(property) }}</td>
                                <td v-else-if="property.input === 'text'">{{ property.pivot.value }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>{{ noDataText }}</p>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import { reactive, toRefs } from 'vue'

export default {

    props: [
        'data',
        'noDataText'
    ],

    setup() {

        const state = reactive({
            activeItem: 0,
            description: null
        })

        function isActive(menuItem) {
            return state.activeItem === menuItem
        }

        function setActive(menuItem) {
            return state.activeItem = menuItem
        }

        function getSelectValue(property) {
            let targetValueId = parseInt(property.pivot.value)
            let returnedValue = null

            property.values.forEach( value => {
                if ( value.id === targetValueId )
                    returnedValue = value.value
            })

            return returnedValue
        }

        return {
            isActive,
            setActive,
            getSelectValue,
            ...toRefs(state)
        }
    }
}
</script>
